export default "__VITE_ASSET__dac8c622__"